import "@hotwired/turbo-rails"
import "./lib/action_pack/passkey"
import "./controllers"
import "../components"

let initialTurboLoad = true
let pageRendered = false

document.addEventListener("turbo:render", () => {
  pageRendered = true
})

document.addEventListener("turbo:load", () => {
  if (initialTurboLoad) {
    // The GTM GA4 base config tag sends the initial page view automatically. Remove this skip if that changes (#604).
    initialTurboLoad = false
    return
  }

  // Promoted Turbo Frame navigations update history and emit turbo:load without rendering a page.
  if (!pageRendered) return

  pageRendered = false
  window.dataLayer?.push({ event: "turbo_page_view" })
})
